import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

interface CustomSvgProps {
  color?: string;
  innerColor?: string;
  [key: string]: any;
}
const CircleStar: React.FC<CustomSvgProps> = ({ color, ...props }) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      d="M12 7.5l1.45 3.68h3.87c.29 0 .41.37.18.54l-3.13 2.27 1.2 3.83c.09.28-.23.51-.47.34L12 15.2l-3.1 2.01c-.24.16-.56-.06-.47-.34l1.2-3.83-3.13-2.27c-.23-.17-.11-.54.18-.54h3.87L12 7.5z"
      fill={color || '#FFF'}
    />
  </Svg>
);

export default CircleStar;
